import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=0bcc6bcf&scoped=true"
import script from "./DealCard.vue?vue&type=script&lang=js"
export * from "./DealCard.vue?vue&type=script&lang=js"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=0bcc6bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc6bcf",
  null
  
)

export default component.exports